var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wait"},[_c('div',{staticClass:"wait-content"},[(_vm.spinnerEnabled)?_c('div',{staticClass:"sk-folding-cube sk-primary"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_c('div',{staticClass:"sk-cube2 sk-cube"}),_c('div',{staticClass:"sk-cube4 sk-cube"}),_c('div',{staticClass:"sk-cube3 sk-cube"})]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }